import APU from "../assets/images/apu.webp";
import Curtin from "../assets/images/curtin-malaysia.webp";
import Help from "../assets/images/help.webp";
import HeriotWatt from "../assets/images/heriot-watt-university-malaysia.webp";
import IGlobal from "../assets/images/iglobal.webp";
import Manipal from "../assets/images/manipal-university-college.webp";
import MIA from "../assets/images/mia.webp";
import QIU from "../assets/images/qiu.webp";
import Raffles from "../assets/images/raffles-university.webp";
import Segi from "../assets/images/segi.webp";
import Southampton from "../assets/images/university-of-southampton-malaysia.webp";
import YTL from "../assets/images/ytl.webp";
import Reading from "../assets/images/university-of-reading-malaysia.webp";
import UOC from "../assets/images/university-of-cyberjaya.webp";
import UOW from "../assets/images/uow.webp";
import PSB from "../assets/images/psb-academy.webp";
import Kaplan from "../assets/images/kaplan-singapore.webp";
import Amity from "../assets/images/amity-global-institute.webp";
import EAIM from "../assets/images/eaim.webp";
import MDIS from "../assets/images/mdis-singapore.webp";
import Teesside from "../assets/images/teesside-university.webp";
import UOSW from "../assets/images/university-of-south-wales.webp";
import UOS from "../assets/images/university-of-sunderland.webp";
import UWE from "../assets/images/uwe-bristol.webp";
import UOH from "../assets/images/university-of-huddersfield.webp";
import UON from "../assets/images/university-of-northampton.webp";
import Coventry from "../assets/images/coventry-university.webp";

export interface PartnerUniversityProps {
  image: string;
  tabHeader: string;
  universityName: string;
  location: string;
  intro: string;
  keyPoint: string[];
}

export const LocalUni: PartnerUniversityProps[] = [
  {
    image: APU,
    tabHeader: "APU",
    universityName: "Asia Pacific University (APU)",
    location: "Kuala Lumpur",
    intro:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi ea,ab sint quas excepturi ullam sit officia, cupiditate adipisci illo ipsa laudantium expedita est! Illo voluptatem quas cumque facilis!",
    keyPoint: ["Strength 1", "Strength 2", "Strength 3"],
  },
  {
    image: Curtin,
    tabHeader: "Curtin",
    universityName: "Curtin University Malaysia",
    location: "Sarawak",
    intro:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi ea,ab sint quas excepturi ullam sit officia, cupiditate adipisci illo ipsa laudantium expedita est! Illo voluptatem quas cumque facilis!",
    keyPoint: ["Strength 1", "Strength 2", "Strength 3"],
  },
  {
    image: Help,
    tabHeader: "Help",
    universityName: "Help University and Academy",
    location: "Kuala Lumpur",
    intro:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi ea,ab sint quas excepturi ullam sit officia, cupiditate adipisci illo ipsa laudantium expedita est! Illo voluptatem quas cumque facilis!",
    keyPoint: ["Strength 1", "Strength 2", "Strength 3"],
  },
  {
    image: HeriotWatt,
    tabHeader: "HWUM",
    universityName: "Heriot-Watt University Malaysia (HWUM)",
    location: "Putrajaya",
    intro:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi ea,ab sint quas excepturi ullam sit officia, cupiditate adipisci illo ipsa laudantium expedita est! Illo voluptatem quas cumque facilis!",
    keyPoint: ["Strength 1", "Strength 2", "Strength 3"],
  },
  {
    image: IGlobal,
    tabHeader: "IGlobal",
    universityName: "IGlobal Academy",
    location: "Shah Alam",
    intro:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi ea,ab sint quas excepturi ullam sit officia, cupiditate adipisci illo ipsa laudantium expedita est! Illo voluptatem quas cumque facilis!",
    keyPoint: ["Strength 1", "Strength 2", "Strength 3"],
  },
  {
    image: Manipal,
    tabHeader: "MUCM",
    universityName: "Manipal University College Malaysia (MUCM)",
    location: "Melaka",
    intro:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi ea,ab sint quas excepturi ullam sit officia, cupiditate adipisci illo ipsa laudantium expedita est! Illo voluptatem quas cumque facilis!",
    keyPoint: ["Strength 1", "Strength 2", "Strength 3"],
  },
  {
    image: MIA,
    tabHeader: "MIA",
    universityName: "Malaysian Institute of Art (MIA)",
    location: "Kuala Lumpur",
    intro:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi ea,ab sint quas excepturi ullam sit officia, cupiditate adipisci illo ipsa laudantium expedita est! Illo voluptatem quas cumque facilis!",
    keyPoint: ["Strength 1", "Strength 2", "Strength 3"],
  },
  {
    image: QIU,
    tabHeader: "QIU",
    universityName: "Quest International University (QIU)",
    location: "Ipoh",
    intro:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi ea,ab sint quas excepturi ullam sit officia, cupiditate adipisci illo ipsa laudantium expedita est! Illo voluptatem quas cumque facilis!",
    keyPoint: ["Strength 1", "Strength 2", "Strength 3"],
  },
  {
    image: Raffles,
    tabHeader: "Raffles",
    universityName: "Raffles University",
    location: "Johor Bahru",
    intro:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi ea,ab sint quas excepturi ullam sit officia, cupiditate adipisci illo ipsa laudantium expedita est! Illo voluptatem quas cumque facilis!",
    keyPoint: ["Strength 1", "Strength 2", "Strength 3"],
  },
  {
    image: Segi,
    tabHeader: "SEGi",
    universityName: "SEGi University and Colleges",
    location: "Petaling Jaya",
    intro:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi ea,ab sint quas excepturi ullam sit officia, cupiditate adipisci illo ipsa laudantium expedita est! Illo voluptatem quas cumque facilis!",
    keyPoint: ["Strength 1", "Strength 2", "Strength 3"],
  },
  {
    image: Southampton,
    tabHeader: "UOSM",
    universityName: "University of Southampton Malaysia",
    location: "Johor",
    intro:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi ea,ab sint quas excepturi ullam sit officia, cupiditate adipisci illo ipsa laudantium expedita est! Illo voluptatem quas cumque facilis!",
    keyPoint: ["Strength 1", "Strength 2", "Strength 3"],
  },
  {
    image: YTL,
    tabHeader: "YTL",
    universityName: "YTL International College of Hotel Management",
    location: "Kuala Lumpur",
    intro:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi ea,ab sint quas excepturi ullam sit officia, cupiditate adipisci illo ipsa laudantium expedita est! Illo voluptatem quas cumque facilis!",
    keyPoint: ["Strength 1", "Strength 2", "Strength 3"],
  },
  {
    image: Reading,
    tabHeader: "UORM",
    universityName: "University of Reading Malaysia (UORM)",
    location: "Johor",
    intro:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi ea,ab sint quas excepturi ullam sit officia, cupiditate adipisci illo ipsa laudantium expedita est! Illo voluptatem quas cumque facilis!",
    keyPoint: ["Strength 1", "Strength 2", "Strength 3"],
  },
  {
    image: UOC,
    tabHeader: "UOC",
    universityName: "University of Cyberjaya (UOC)",
    location: "Cyberjaya",
    intro:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi ea,ab sint quas excepturi ullam sit officia, cupiditate adipisci illo ipsa laudantium expedita est! Illo voluptatem quas cumque facilis!",
    keyPoint: ["Strength 1", "Strength 2", "Strength 3"],
  },
  {
    image: UOW,
    tabHeader: "UOW",
    universityName: "University of Wollongong Malaysia (UOW)",
    location: "Shah Alam",
    intro:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi ea,ab sint quas excepturi ullam sit officia, cupiditate adipisci illo ipsa laudantium expedita est! Illo voluptatem quas cumque facilis!",
    keyPoint: ["Strength 1", "Strength 2", "Strength 3"],
  },
];

export const OverseasUni: PartnerUniversityProps[] = [
  {
    image: PSB,
    tabHeader: "PSB",
    universityName: "PSB Academy",
    location: "Singapore",
    intro:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi ea,ab sint quas excepturi ullam sit officia, cupiditate adipisci illo ipsa laudantium expedita est! Illo voluptatem quas cumque facilis!",
    keyPoint: ["Strength 1", "Strength 2", "Strength 3"],
  },
  {
    image: Kaplan,
    tabHeader: "Kaplan",
    universityName: "Kaplan International Pathway Singapore",
    location: "Singapore",
    intro:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi ea,ab sint quas excepturi ullam sit officia, cupiditate adipisci illo ipsa laudantium expedita est! Illo voluptatem quas cumque facilis!",
    keyPoint: ["Strength 1", "Strength 2", "Strength 3"],
  },
  {
    image: Amity,
    tabHeader: "Amity",
    universityName: "Amity Global Institute",
    location: "Singapore",
    intro:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi ea,ab sint quas excepturi ullam sit officia, cupiditate adipisci illo ipsa laudantium expedita est! Illo voluptatem quas cumque facilis!",
    keyPoint: ["Strength 1", "Strength 2", "Strength 3"],
  },
  {
    image: EAIM,
    tabHeader: "EAIM",
    universityName: "East Asia Institute of Management (EAIM)",
    location: "Singapore",
    intro:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi ea,ab sint quas excepturi ullam sit officia, cupiditate adipisci illo ipsa laudantium expedita est! Illo voluptatem quas cumque facilis!",
    keyPoint: ["Strength 1", "Strength 2", "Strength 3"],
  },
  {
    image: MDIS,
    tabHeader: "MDIS",
    universityName: "Management Development Institute of Singapore (MDIS)",
    location: "Singapore",
    intro:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi ea,ab sint quas excepturi ullam sit officia, cupiditate adipisci illo ipsa laudantium expedita est! Illo voluptatem quas cumque facilis!",
    keyPoint: ["Strength 1", "Strength 2", "Strength 3"],
  },
  {
    image: Teesside,
    tabHeader: "Teesside",
    universityName: "Teesside University",
    location: "United Kingdom",
    intro:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi ea,ab sint quas excepturi ullam sit officia, cupiditate adipisci illo ipsa laudantium expedita est! Illo voluptatem quas cumque facilis!",
    keyPoint: ["Strength 1", "Strength 2", "Strength 3"],
  },
  {
    image: UOSW,
    tabHeader: "UOSW",
    universityName: "University of South Wales",
    location: "United Kingdom",
    intro:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi ea,ab sint quas excepturi ullam sit officia, cupiditate adipisci illo ipsa laudantium expedita est! Illo voluptatem quas cumque facilis!",
    keyPoint: ["Strength 1", "Strength 2", "Strength 3"],
  },
  {
    image: UOS,
    tabHeader: "UOS",
    universityName: "University of Sunderland",
    location: "United Kingdom",
    intro:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi ea,ab sint quas excepturi ullam sit officia, cupiditate adipisci illo ipsa laudantium expedita est! Illo voluptatem quas cumque facilis!",
    keyPoint: ["Strength 1", "Strength 2", "Strength 3"],
  },
  {
    image: UWE,
    tabHeader: "UWE Bristol",
    universityName: "University of the West of England (UWE Bristol)",
    location: "United Kingdom",
    intro:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi ea,ab sint quas excepturi ullam sit officia, cupiditate adipisci illo ipsa laudantium expedita est! Illo voluptatem quas cumque facilis!",
    keyPoint: ["Strength 1", "Strength 2", "Strength 3"],
  },
  {
    image: UOH,
    tabHeader: "UOH",
    universityName: "University of Huddersfield",
    location: "United Kingdom",
    intro:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi ea,ab sint quas excepturi ullam sit officia, cupiditate adipisci illo ipsa laudantium expedita est! Illo voluptatem quas cumque facilis!",
    keyPoint: ["Strength 1", "Strength 2", "Strength 3"],
  },
  {
    image: UON,
    tabHeader: "UON",
    universityName: "University of Northampthon",
    location: "United Kingdom",
    intro:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi ea,ab sint quas excepturi ullam sit officia, cupiditate adipisci illo ipsa laudantium expedita est! Illo voluptatem quas cumque facilis!",
    keyPoint: ["Strength 1", "Strength 2", "Strength 3"],
  },
  {
    image: Coventry,
    tabHeader: "Coventry",
    universityName: "Coventry University",
    location: "United Kingdom",
    intro:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi ea,ab sint quas excepturi ullam sit officia, cupiditate adipisci illo ipsa laudantium expedita est! Illo voluptatem quas cumque facilis!",
    keyPoint: ["Strength 1", "Strength 2", "Strength 3"],
  },
];

export const UniImage = [
  APU,
  Curtin,
  Help,
  IGlobal,
  Manipal,
  MIA,
  QIU,
  Segi,
  YTL,
  UOC,
  UOW,
  PSB,
  Kaplan,
  Amity,
  EAIM,
  MDIS,
  Teesside,
  UOSW,
  UOS,
  UWE,
  UOH,
  UON,
  Coventry,
];
